import { Modal, SystemText } from 'e4shared';
import React from 'react';

export const Upload = ({ file, setFile, show, onClose, loading, fileErrors }) => {
    return (
        <Modal title={SystemText('Admin/Languages/Upload/Title', show)} show={show} close={onClose} footer={null}>
            <label className="custom-file-upload btn btn-primary" disabled={loading}>
                <input
                    type="file"
                    data-testid="file-bulkupload"
                    onClick={e => {
                        e.target.value = '';
                        setFile(null);
                    }}
                    onChange={e => e.target.files && setFile(e.target.files[0])}
                />
                <i className={`fa ${loading ? 'fa-spinner fa-spin' : 'fa-cloud-upload'} mr10`}></i>
                {SystemText('Admin/Languages/Upload/Button')}
            </label>
            {fileErrors?.length > 0 && (
                <div className="flex flex-center">
                    <div className="text-danger mr10">
                        <i className="fa fa-lg fa-warning" />
                    </div>
                    <div className="flex-grow">
                        <h3 className="text-danger">{SystemText('Admin/Languages/Upload/Errors')}</h3>
                        {fileErrors.map((e, i) => (
                            <div key={`file-error-${i}`}>
                                {e.item2 ? (
                                    <>
                                        Line {e.item2}: {e.item1}
                                    </>
                                ) : (
                                    <>{e}</>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default Upload;
